
import './App.css';
import './Mediaquery.css';
import { BrowserRouter as Router, Routes, Route, Navigate } from 'react-router-dom';
import LoginPage from './pages/LoginPage';
import RegisterPage from './pages/Registerpage'
import Navbar from './components/Navbar'
import {toast, ToastContainer} from 'react-toastify'
import 'react-toastify/dist/ReactToastify.css';
import Resetpass from './pages/Resetpass';
import Chatpage from './pages/Chatpage';
import { useContext } from 'react';
import { AuthContext } from './context/AuthContext';
import Footer from './components/Footer';
import Somewhere from './pages/Somewhere';
function App() {

  const {currentuser} = useContext(AuthContext)
 
  const PrivateRoute = ({children}) =>{
    if(!currentuser){
    return <Navigate to="/login" />
    }
    return children; 
  }
  return (
    <div className="App">
      <Router>
        <ToastContainer />
        <Navbar />
        <Routes>
          <Route path='/login' element={<LoginPage />}></Route>
          <Route path='/signup' element={<RegisterPage />}></Route>
          <Route path='resetpassword' element= { <Resetpass />} ></Route>
          <Route path='/' element={<PrivateRoute> <Chatpage/> </PrivateRoute>}></Route>
          <Route path='*' element= { <Somewhere />} ></Route>
        </Routes>
        <Footer />
      </Router>
    </div>
  );
}

export default App;
